<template>
  <div>
    <el-row class="querypanel">
        <el-col :span="24">
          <el-form ref="form"  label-width="120px" label-position="left">
            <el-form-item label="注册日期:">
              <el-date-picker
                v-model="bymemberdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24">
          <div>
            <el-button style="margin-top: 10px; margin-left: 10px;" @click="querymember">查询会员</el-button>
            <el-button style="margin-top: 10px; margin-left: 10px;" @click="savemlabel">保存标签</el-button>
          </div>
        </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-col :span="14">
        <el-table
          stripe
          :data="memberdata"
          ref="multipleTable">
          <el-table-column
            prop="nickname.String"
            width = "200px"
            label="会员昵称">
          </el-table-column>
          <el-table-column
            prop="phone.String"
            label="电话号码">
          </el-table-column>
          <el-table-column
            label="操作"
            width="120px"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="选择用户" placement="top-start">
                <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="selectmember(scope.$index, memberdata)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="10">
        <el-form label-width="120px" label-position="left">
          <el-tag
            :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'PageInfo',
  data () {
    return {
      dynamicTags: ['新客户', '购买频繁', '购买价值较高'],
      inputVisible: false,
      inputValue: '',
      selectuserid: 0,
      memberdata: [],
      khid: ''
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    console.log(that)
  },
  methods: {
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    selectmember (index, data) {
      console.log(data[index])
      this.selectuserid = data[index].id
    },
    querymember () {
      var qstr = 'usergroups_id = 2 and cus_id= ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/account/getuserlist',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.memberdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savemlabel () {
      console.log('保存标签')
      console.log(that.dynamicTags)
      if (that.selectuserid === 0) {
        that.$message({
          type: 'info',
          message: '请先选择会员!'
        })
      } else {
        var adddata = {
          userid: parseInt(that.selectuserid),
          memberlabels: {String: that.dynamicTags.toString(), Valid: true},
          cusid: parseInt(that.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/cardticket/aaubml',
          method: 'post',
          data: adddata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.$message({
                type: 'success',
                message: '标签标注成功!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
        console.log(adddata)
      }
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/member/MemberLabel.vue